function TipNotificationCtrl() {
  _initScope();

  function _initScope() {}
}

TipNotificationCtrl.$inject = [];

export default TipNotificationCtrl;



// WEBPACK FOOTER //
// ./src/directives/tipNotification/controller.js